import React, { useState } from 'react';
import './ToolPage.css';

const TextCaseConverter = () => {
  const [input, setInput] = useState('');
  const [output, setOutput] = useState('');

  const toUpperCase = () => setOutput(input.toUpperCase());
  const toLowerCase = () => setOutput(input.toLowerCase());

  const toTitleCase = () => {
    setOutput(input.toLowerCase().replace(/\b\w/g, char => char.toUpperCase()));
  };

  const toSentenceCase = () => {
    setOutput(input.toLowerCase().replace(/(^\s*\w|[.!?]\s*\w)/g, char => char.toUpperCase()));
  };

  const toCamelCase = () => {
    const result = input
      .toLowerCase()
      .replace(/[^a-zA-Z0-9]+(.)/g, (_, char) => char.toUpperCase());
    setOutput(result);
  };

  const toPascalCase = () => {
    const result = input
      .toLowerCase()
      .replace(/(^|[^a-zA-Z0-9]+)(.)/g, (_, __, char) => char.toUpperCase());
    setOutput(result);
  };

  const toSnakeCase = () => {
    const result = input
      .replace(/\s+/g, '_')
      .replace(/([a-z])([A-Z])/g, '$1_$2')
      .toLowerCase();
    setOutput(result);
  };

  const toKebabCase = () => {
    const result = input
      .replace(/\s+/g, '-')
      .replace(/([a-z])([A-Z])/g, '$1-$2')
      .toLowerCase();
    setOutput(result);
  };

  const copyOutput = () => {
    navigator.clipboard.writeText(output);
  };

  const clearAll = () => {
    setInput('');
    setOutput('');
  };

  return (
    <div className="tool-page">
      <div className="tool-header">
        <h1 className="tool-title">Text Case Converter</h1>
        <p className="tool-description">
          Convert text between different cases (upper, lower, title, camel, etc.)
        </p>
      </div>

      <div className="tool-content">
        <div className="textarea-group">
          <label className="input-label">Input Text</label>
          <textarea
            className="textarea-field"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            placeholder="Enter your text here"
            rows={6}
          />
        </div>

        <div className="case-buttons">
          <button className="case-btn" onClick={toUpperCase}>UPPERCASE</button>
          <button className="case-btn" onClick={toLowerCase}>lowercase</button>
          <button className="case-btn" onClick={toTitleCase}>Title Case</button>
          <button className="case-btn" onClick={toSentenceCase}>Sentence case</button>
          <button className="case-btn" onClick={toCamelCase}>camelCase</button>
          <button className="case-btn" onClick={toPascalCase}>PascalCase</button>
          <button className="case-btn" onClick={toSnakeCase}>snake_case</button>
          <button className="case-btn" onClick={toKebabCase}>kebab-case</button>
        </div>

        <div className="textarea-group">
          <label className="input-label">Output</label>
          <textarea
            className="textarea-field"
            value={output}
            readOnly
            placeholder="Converted text will appear here"
            rows={6}
          />
        </div>

        <div className="button-row">
          <button className="action-btn" onClick={copyOutput} disabled={!output}>
            Copy Output
          </button>
          <button className="clear-btn" onClick={clearAll}>
            Clear
          </button>
        </div>
      </div>
    </div>
  );
};

export default TextCaseConverter;
